import { imprimirQRCodeGerente } from 'modulo-gerencial-erp-pacotes-impressora-termica';

import { imprimirServicoNovo, buscarDadosImpressao } from '../utils';

async function imprimir(id, query = '', usar_nova_impressao = false) {
  /* if (!usar_nova_impressao) {
    return await imprimirServicoAntigo(id, 11, query);
  }

  const dados = await buscarDadosImpressao(id, 11);

  const { comandos } = layout(adapter(dados));

  const response = await imprimirServicoNovo(id, 'qrcode-gerente', comandos);
  return response.data; */

  return await imprimirQRCodeGerente({
    id,
    buscarDadosImpressao,
    chamarServicoImpressoraTermica: imprimirServicoNovo,
    query: '',
  });
}

export default imprimir;
